import { css } from "@emotion/react";

const skeletonHeight = "height: 2.75rem";

export const header = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1rem 0;
`;

export const title = css`
  align-self: center;
`;

export const actions = css`
  display: flex;
  justify-content: flex-end;
`;

export const titleSkeleton = css`
  ${skeletonHeight};
`;

export const sortDropdownSkeleton = css`
  ${skeletonHeight};
`;
export const gridListSelector = css`
  margin-top: 0;
  margin-left: 1rem;
  ${skeletonHeight};
`;
